// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PX9WO","right":"styles_right__3GMsk"};